export default {
    "uberId": "u.78AFFCD3-56E0-EC2A-B772-F2B548B6F9FF",
    "effectiveTimestamp": "2020-10-15 13:57:31.0",
    "expirationTimestamp": null,
    "genderType": {
        "typeId": 397, "typeCd": "MAL", "typeName": "Male"
    },
    "financialExperienceLevelType": {
        "typeId": 400, "typeCd": "BEG", "typeName": "Beginner"
    },
    "origUserId": "AAR",
    "origTimeStamp": "2020-10-15 13:57:31.531072",
    "lastUpdatedUserId": "RWS",
    "lastUpdatedTimeStamp": "2023-07-07 09:48:00.469821",
    "investmentsGoals": [
        {
            "clientProfileInvestmentGoals": {
                "typeId": 392, "typeCd": "RET", "typeName": "Retirement Planning"
            },
            "origUserId": "RWS",
            "origTimeStamp": "2023-07-07 09:48:00.556638",
            "lastUpdatedUserId": "RWS",
            "lastUpdatedTimeStamp": "2023-07-07 09:48:00.556638"
        }, {
            "clientProfileInvestmentGoals": {
                "typeId": 394, "typeCd": "DBT", "typeName": "Debt Management"
            },
            "origUserId": "RWS",
            "origTimeStamp": "2023-07-07 09:48:00.60908",
            "lastUpdatedUserId": "RWS",
            "lastUpdatedTimeStamp": "2023-07-07 09:48:00.60908"
        }, {
            "clientProfileInvestmentGoals": {
                "typeId": 396, "typeCd": "HCR", "typeName": "Health Care"
            },
            "origUserId": "RWS",
            "origTimeStamp": "2023-07-07 09:48:00.61538",
            "lastUpdatedUserId": "RWS",
            "lastUpdatedTimeStamp": "2023-07-07 09:48:00.61538"
        }],
    "attributes": [{
        "uberId": "u.78AFFCD3-56E0-EC2A-B772-F2B548B6F9FF",
        "attributeType": {
            "typeId": 458, "typeCd": "PAYF", "typeName": "Payroll Frequency"
        },
        "clientProfileEffectiveTimestamp": "2020-10-15 13:57:31.0",
        "sequenceNumber": 0,
        "effectiveTimestamp": "2020-10-15 13:57:31.605734",
        "expirationTimestamp": null,
        "date": null,
        "value": null,
        "text": null,
        "timestamp": null,
        "amount": 0.0,
        "indicator": false,
        "referenceType": 64,
        "referenceValue": 463,
        "origUserId": "AAR",
        "origTimeStamp": "2020-10-15 13:57:31.605734",
        "lastUpdatedUserId": "AAR",
        "lastUpdatedTimeStamp": "2020-10-15 13:57:31.605734"
    },
        {
            "uberId": "u.E4AC336A-6365-DF86-965C-26D7D3579FA5",
            "attributeType": {
                "typeId": 459,
                "typeCd": "MTRT",
                "typeName": "Marginal Tax Rate"
            },
            "clientProfileEffectiveTimestamp": "2020-01-17 11:27:32.0",
            "sequenceNumber": 0,
            "effectiveTimestamp": "2021-10-19 15:21:23.874506",
            "expirationTimestamp": null,
            "date": null,
            "value": null,
            "text": null,
            "timestamp": null,
            "amount": 5.0,
            "indicator": false,
            "referenceType": null,
            "referenceValue": null,
            "origUserId": "RWS",
            "origTimeStamp": "2021-10-19 15:21:23.874506",
            "lastUpdatedUserId": "RWS",
            "lastUpdatedTimeStamp": "2021-10-19 15:21:48.287328"
        }
    ]
}
